<div style="position: absolute; width: 100%; height: 100%; background-color: rgba(255,255,255,0.4)" 
        *ngIf="!loaded" 
        [@simpleFadeAnimation]="'in'">
    <span style="position: absolute; top: 50%; left: 50%;">
        <mat-progress-spinner color="primary"
                            mode="indeterminate"
                            diameter="50"></mat-progress-spinner>
    </span>        
</div>